/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// material
import { Card, Container } from '@material-ui/core';
import useSettings from 'src/hooks/useSettings';
import TableSearch from 'src/components/table/TableSearch';
import { USER_ROLE_LIST_HEAD } from 'src/constants/Dashboard';
import { useSnackbar } from 'notistack5';
import {
  filterUserRole,
  deleteUserRole,
  statusChange,
  resetUserRoleMsg,
  resetCreateUserRoleStatus
} from 'src/redux/slices/user_role';
import { useDispatch, useSelector } from 'src/redux/store';
import AlertDialog from 'src/components/common-components/AlertDialog';

// ----------------------------------------------------------------------
UserRoleList.propTypes = {
  setEditId: PropTypes.func,
  setDeleteId: PropTypes.func,
  setUserRoleListStatus: PropTypes.func,
  deleteId: PropTypes.string,
  userRoleList: PropTypes.array,
  userRoleListStatus: PropTypes.bool,
  loading: PropTypes.bool
};
// ----------------------------------------------------------------------

export default function UserRoleList({
  setEditId,
  setDeleteId,
  setUserRoleListStatus,
  deleteId,
  userRoleList,
  userRoleListStatus,
  loading
}) {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const dispatch = useDispatch();
  const { createUserRoleStatus, userRoleMsg } = useSelector((state) => state.user_role);

  useEffect(() => {
    if (createUserRoleStatus) {
      enqueueSnackbar('User Role Disabled Successfully', { variant: 'success' });
      dispatch(resetCreateUserRoleStatus());
    }
    if (userRoleMsg) {
      setClose(true);
      setOpen(true);
      dispatch(resetUserRoleMsg());
      setTitle('Disable User ole');
      setContent(userRoleMsg);
    }
  }, [userRoleMsg, createUserRoleStatus]);

  const handleUserRoleListSwitch = (e) => {
    setUserRoleListStatus(!e.target.checked);
  };

  const handleDelete = (id) => {
    setClose(false);
    setTitle('Delete user Role');
    setContent('Are you sure want to delete User Role data permanently??');
    setOpen(true);
    setDeleteId(id);
  };

  const handleDeleteDispatch = () => {
    dispatch(deleteUserRole(deleteId));
    enqueueSnackbar('User Role Deleted Successfully', {
      variant: 'success'
    });
    setOpen(false);
  };

  const handleDisable = async (id) => {
    dispatch(statusChange(id, false));
  };

  const handleRestore = async (id) => {
    dispatch(statusChange(id, true));
    enqueueSnackbar('user Role Restore Successfully', {
      variant: 'success'
    });
  };

  const handleEdit = (id) => {
    setEditId(id);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container maxWidth={themeStretch ? false : 'lg'} style={{ padding: 0 }}>
      <Card>
        <AlertDialog
          title={title}
          content={content}
          okFunction={close ? handleClose : handleDeleteDispatch}
          open={open}
          setOpen={setOpen}
        />
        <TableSearch
          tableHead={USER_ROLE_LIST_HEAD}
          tableData={userRoleList}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleDisable={handleDisable}
          handleRestore={handleRestore}
          status={userRoleListStatus}
          switchButton
          filterComponent={filterUserRole}
          switchButtonResponse={handleUserRoleListSwitch}
          loading={loading}
        />
      </Card>
    </Container>
  );
}
